export const ONBOARDING_TOKENS = {
  cream: '#FFFCF6',
  cream2: '#FCF8F0',
  cream3: '#F5F0E8',
  ink: '#0B0B0B',
  ink2: '#333333',
  ink3: '#666666',
  ink4: '#999999',
  line: '#EFE8E0',
  line2: '#E8E0D8',
  sun: '#E9902C',
  sunLight: '#F0A859',
  sunPale: '#FCEFE0',
  sunPale2: '#F9D8B3',
  sunDark: '#C57316',
  green: '#1F8A5B',
  greenPale: '#DCEFE5',
  blue: '#2A6FDB',
  red: '#B4372A',
  redPale: '#FBE7E3',
  redLine: '#F0C3BA',
  shadowCard: '0 1px 0 rgba(11,11,11,.04), 0 24px 48px -28px rgba(11,11,11,.18)',
  fontSans: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontSerif: '"Instrument Serif", "Georgia", serif',
  fontMono: '"JetBrains Mono", ui-monospace, "SF Mono", monospace',
} as const;
